class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 1;
    this.products = Array.from(this.querySelectorAll('.product-item'));
    this.prevBtn = this.querySelector('#prev-btn');
    this.nextBtn = this.querySelector('#next-btn');
    this.variants = customKitProducts;
    this.querySelectorAll(".variant-selector select.option-select").forEach((select) => select.addEventListener("change", this.changeOptions.bind(this)));
  }

  connectedCallback() {
    this.nextBtn.addEventListener('click', () => this.navigate(1));
    this.prevBtn.addEventListener('click', () => this.navigate(-1));
    this.updateDisplay();
    
    // Verificação inicial da primeira variante
    setTimeout(() => {
      const firstProduct = this.querySelector('.product-item[data-index="1"]');
      if (firstProduct) {
        const firstProductId = parseInt(firstProduct.getAttribute("data-product-id"));
        this.updateSelectedVariantInfos(firstProductId, 1);
      }
    }, 100);
  }

  navigate(step) {
    if (step > 0) {
      this.nextBtn.classList.add("is-loading");
      setTimeout(() => {
        this.nextBtn.classList.remove("is-loading");
      }, 400);
    }
    this.currentIndex += step;
    if (this.currentIndex > this.products.length) {
      this.addItemsToCart();
      this.currentIndex = this.products.length;
      return;
    }
    this.updateDisplay();
  }

  updateDisplay() {
    this.products.forEach((product, index) => {
      product.setAttribute("active", (parseInt(product.getAttribute("data-index")) === this.currentIndex).toString());
    });
    const product = this.querySelector(`.product-item[data-index="${this.currentIndex}"]`);
    const productId = parseInt(product.getAttribute("data-product-id"));
    const productIndex = parseInt(product.getAttribute("data-index"));
    this.updateSelectedVariantInfos(productId, productIndex);

    this.querySelector("#pagination .current-page").innerText = this.currentIndex;

    this.prevBtn.hidden = this.currentIndex === 1;
    this.nextBtn.disabled = false;
    this.nextBtn.querySelector("span").textContent = this.currentIndex === this.products.length ? 'Adicionar itens ao carrinho' : 'Ir para o próximo item';
  }

  addItemsToCart() {
    this.nextBtn.classList.add("is-loading");
    const itemsToAdd = [];
    const selectedVariants = [];
    this.products.forEach((product) => {
      const selectedOptions = Array.from(
        product.querySelectorAll(`select.option-select`)
      ).map(select => select.value);
      const productId = parseInt(product.getAttribute("data-product-id"));
      const productVariants = this.variants.find((variant) => variant.productId === productId)?.variants;
      let selectedVariant = productVariants.find((v) => v.available && arraysContemMesmosElementos(v.options, selectedOptions));
      if (selectedVariant) {
        itemsToAdd.push({
          id: selectedVariant.id,
          quantity: 1,
          'product-id': productId
        });
        selectedVariants.push(selectedVariant);
      }
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    })
      .then(response => response.json())
      .then(data => {
        window.cartDrawer.getCart();

        window.VWO = window.VWO || [];
        VWO.event = VWO.event || function () {
          VWO.push(["event"].concat([].slice.call(arguments)));
        };

        if (selectedVariants.length > 0) {
          const firstVariant = selectedVariants[0];

          VWO.event("shopify.productAddedToCart", {
            currency: "BRL",
            productId: String(firstVariant.productId),
            productTitle: firstVariant.title,
            quantity: selectedVariants.length,
            totalAmount: parseFloat(firstVariant.price.replace(",", ".")),
            variantId: "Kit Customizado"
          });
        }

        this.nextBtn.classList.remove("is-loading");
      })
      .catch(error => {
        console.error('Error adding items to cart:', error);
        this.nextBtn.classList.remove("is-loading");
      });
  }

  updateSelectedVariantInfos(productId, index) {
    const product = this.querySelector(`.product-item[data-product-id="${productId}"][data-index="${index}"]`);
    const selectedVariant = this.getSelectedVariant(product);

    if (!selectedVariant || !selectedVariant.available) {
      this.nextBtn.querySelector("span").textContent = 'Tamanho Indisponível';
      this.nextBtn.disabled = true;
      this.nextBtn.classList.remove("add-to-cart");
    } else {
      const isLastItem = this.currentIndex === this.products.length;
      this.nextBtn.querySelector("span").textContent = isLastItem ? 'Adicionar itens ao carrinho' : 'Ir para o próximo item';
      this.nextBtn.classList.toggle("add-to-cart", isLastItem);
      this.nextBtn.disabled = false;
    }

    const image = selectedVariant?.image;
    if (image) {
      product.querySelector(".product-image img").src = image;
      product.querySelector(".product-image img").srcset = image;
    }

    //Atualiza o preço da variante selecionada
    if (selectedVariant) {
      const compare_at_price = parseFloat(selectedVariant.compare_at_price.toString().replace(",", "."));
      const price = parseFloat(selectedVariant.price.toString().replace(",", "."));
      const discount = parseFloat(selectedVariant.discount.toString().replace(",", "."));

      if (!isNaN(compare_at_price) && compare_at_price > price) {
        product.querySelector(".product-info .price .original-price").innerText = `R$ ${(compare_at_price).toFixed(2).toString().replace(".", ",")}`;
        product.querySelector(".product-info .price .current-price").innerText = `R$ ${((compare_at_price - discount * compare_at_price * 0.01) * 0.98).toFixed(2).toString().replace(".", ",")} no pix`;
        product.querySelector(".installments").innerText = `${(compare_at_price - discount * compare_at_price * 0.01).toFixed(2).toString().replace(".", ",")} no cartão ou em 3x de ${((compare_at_price - discount * compare_at_price * 0.01) / 3).toFixed(2).toString().replace(".", ",")} sem juros`;
      } else {
        product.querySelector(".product-info .price .original-price").innerText = `R$ ${price.toFixed(2).toString().replace(".", ",")}`;
        product.querySelector(".product-info .price .current-price").innerText = `R$ ${((price - (discount * price * 0.01)) * 0.98).toFixed(2).toString().replace(".", ",")} no pix`;
        product.querySelector(".installments").innerText = `${(price - discount * price * 0.01).toFixed(2).toString().replace(".", ",")} no cartão ou em 3x de ${((compare_at_price - discount * compare_at_price * 0.01) / 3).toFixed(2).toString().replace(".", ",")} sem juros`;
      }
    }

    this.selectImageOnCarousel(productId, index);
  }

  selectImageOnCarousel(productId, index) {
    if (!this.querySelector(`.product-item[data-product-id="${productId}"][data-index="${index}"] .labels-container[data-option='Estilo']`) && !this.querySelector(`.product-item[data-product-id="${productId}"][data-index="${index}"] .labels-container[data-option='Cor']`)) return;
    const color = this.querySelector(`.product-item[data-product-id="${productId}"][data-index="${index}"] .labels-container[data-option='Estilo']`)?.value || this.querySelector(`.product-item[data-product-id="${productId}"][data-index="${index}"] .labels-container[data-option='Cor']`)?.value;

    const thumb = document.querySelector(`.featured-product[data-section-id=${this.getAttribute("data-section-id")}] .product-single__thumbnails .product-single__thumbnail img[alt="${color}"]`);
    const container = document.querySelector(`.featured-product[data-section-id=${this.getAttribute("data-section-id")}]`);

    thumb && container.selectCarouselImage && container.selectCarouselImage(parseInt(thumb.getAttribute("data-index")) - 1);
  }

  getSelectedVariant(product) {
    const selectedOptions = Array.from(
      product.querySelectorAll(`select.option-select`)
    ).map(select => select.value);
    const productId = parseInt(product.getAttribute("data-product-id"));
    const productVariants = this.variants.find((variant) => variant.productId === productId)?.variants;
    return productVariants.find((v) => arraysContemMesmosElementos(v.options, selectedOptions));
  }

  changeOptions(event) {
    const select = event.target;
    const optionName = select.getAttribute("data-option");
    const productId = parseInt(select.getAttribute("data-product-id"));
    const index = parseInt(select.getAttribute("data-index"));

    this.updateSelectedVariantInfos(productId, index, optionName);
  }
}

function arraysSaoIguais(array1, array2) {
  if (array1.length !== array2.length) return false;
  for (let i = 0; i < array1.length; i++) {
    if (array1[i] !== array2[i]) return false;
  }
  return true;
}

function arraysContemMesmosElementos(array1, array2) {
  const sortedArray1 = array1.slice().sort();
  const sortedArray2 = array2.slice().sort();
  return arraysSaoIguais(sortedArray1, sortedArray2);
}

customElements.define('custom-kit', ProductCarousel);